import { setAlpha } from '@talos/kyoko';
import type { DefaultTheme } from 'styled-components';

export type PredictionLeg = 'yes' | 'no';

export function predictionLegTextColor(leg: PredictionLeg, theme: DefaultTheme): string {
  return leg === 'yes' ? theme.colors.green.lighten : theme.colors.red.lighten;
}

export function predictionLegSurfaceColor(leg: PredictionLeg, theme: DefaultTheme, alpha: number): string {
  return setAlpha(alpha, leg === 'yes' ? theme.colors.green.default : theme.colors.red.default);
}
